import {Action, createReducer, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import {Conversation} from './conversation.model';
import * as ConversationActions from './conversation.actions';

export const conversationsFeatureKey = 'conversations';

export interface State extends EntityState<Conversation> {
  // additional entities state properties
  loaded: boolean;
  lastUpdate: Date | number;
}

export const adapter: EntityAdapter<Conversation> = createEntityAdapter<Conversation>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
  lastUpdate: null
});


export const reducer = createReducer(
  initialState,
  on(ConversationActions.addConversation,
    (state, action) => adapter.addOne(action.conversation, state)
  ),
  on(ConversationActions.upsertConversation,
    (state, action) => adapter.upsertOne(action.conversation, state)
  ),
  on(ConversationActions.addConversations,
    (state, action) => adapter.addMany(action.conversations, state)
  ),
  on(ConversationActions.upsertConversations,
    (state, action) => adapter.upsertMany(action.conversations, state)
  ),
  on(ConversationActions.updateConversation,
    (state, action) => adapter.updateOne(action.conversation, state)
  ),
  on(ConversationActions.updateConversations,
    (state, action) => adapter.updateMany(action.conversations, state)
  ),
  on(ConversationActions.deleteConversation,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ConversationActions.deleteConversations,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ConversationActions.loadConversations,
    (state, action) => adapter.setAll(action.conversations, state)
  ),
  on(ConversationActions.clearConversations,
    state => adapter.removeAll(state)
  ),
    on(ConversationActions.loadConversationsSuccess,
      (state, action) => {
        if (action.conversation != null) {
          return adapter.upsertMany([action.conversation], { ...state, loaded: true, lastUpdate: Date.now() });
        } else {
          return state;
        }
      }
    ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
